var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.authorsCount)?_c('span',{},[_c('span',[_vm._v(_vm._s(_vm.authorNames[0]))]),(_vm.authorNames.length > 1)?_c('span',[_vm._v(", "+_vm._s(_vm.authorNames[1]))]):_vm._e(),(_vm.authorNames.length > 2)?_c('span',[_vm._v(", et al.")]):_vm._e()]):_c('span',[_vm._v(" No authors ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }